/** @jsx jsx */
import React, { useCallback, useState } from 'react';
import { jsx } from '@emotion/react';
import parser from 'ua-parser-js';
import { Button, Classes, Dialog, Intent } from '@blueprintjs/core';

// based on support for grid gap
// https://caniuse.com/mdn-css_properties_gap_grid_context
const supportedBrowsers = {
	Chrome: 66,
	Firefox: 61,
	Edge: 16,
	Opera: 53,
	Safari: 12,
};

function isSupportedBrowser(): boolean {
	try {
		const UAP = parser(navigator.userAgent);
		const targetVersion = supportedBrowsers[UAP.browser.name];
		const browserVersion = +UAP.browser.major;
		if (targetVersion && targetVersion <= browserVersion) {
			return true;
		}
	} catch (e) {
		console.error('Slykit: Unable to determine browser version.', e);
	}
	return false;
}

/**
 * Renders children only if browser supports slykit. Override option is available.
 */
export const BrowserChecker: React.FC = ({ children }) => {
	const [isSupported, setIsSupported] = useState(() => {
		return isSupportedBrowser();
	});

	const dismiss = useCallback(() => {
		setIsSupported(true);
	}, []);

	return (
		<React.Fragment>
			{isSupported ? (
				children
			) : (
				<Dialog title="Unsupported Browser" isOpen={!isSupported} icon={'warning-sign'}>
					<div className={Classes.DIALOG_BODY}>
						Features might not work as expected on your browser. Please switch to one of the browsers below.
						<ul>
							{Object.entries(supportedBrowsers).map(([browser, version]) => {
								return (
									<li key={browser}>
										{browser} v{version} or greater
									</li>
								);
							})}
						</ul>
					</div>
					<div className={Classes.DIALOG_FOOTER}>
						<div className={Classes.DIALOG_FOOTER_ACTIONS}>
							<Button onClick={dismiss} intent={Intent.DANGER}>
								Continue Anyway
							</Button>
						</div>
					</div>
				</Dialog>
			)}
		</React.Fragment>
	);
};
